<div class="mlpa-jobs-search">
  <div class="mlpa-jobs-search__inner">
    <span *ngIf="(!term || term == '') && !isLoading" class="material-icons search-icon" title="Not quite 100 zeroes">&#xE8B6;</span>
    <span *ngIf="(term && term !== '')" class="material-icons clear-icon" (click)="clear();" title="Clear">&#xE14C;</span>
    <input class="mlpa-jobs-search__input-ga" [(ngModel)]="term" (keydown.enter)="keyUp.next($event)" (keyup)="keyUp.next($event)" type="text" id="term" [placeholder]="placeholder" />
    <span class="loading" [class.visible]="isLoading"></span>
    <span *ngIf="term" class="result-status" [class.visible]="term">{{results | number}} Results</span>
  </div>
</div>
